import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form } from 'react-bootstrap';
import WordCountIndicator from './WordCountIndicator';

const CandidateReportCard = ({
  candidateReport,
  index,
  isEditable,
  fieldStatus,
  hasError,
  onChange,
  showExpertise = false,
  expertiseStatus = null,
  onExpertiseChange = null,
  fieldPrefix = '',
}) => {
  const expertiseValue = candidateReport.fieldOfExpertise || '';
  const expertiseOver = !!expertiseStatus?.over;

  return (
    <Card className="mb-5" id={`field-${fieldPrefix}candidate-${index}`}>
      <Card.Header className="bg-light py-2">
        <strong>
          Rank {candidateReport.candidateRank}: {candidateReport.candidateName}
        </strong>
      </Card.Header>
      <Card.Body>
        {showExpertise && (
          <Form.Group
            className="mb-3"
            id={`field-${fieldPrefix}candidate-expertise-${index}`}
          >
            <Form.Label className="small text-muted mb-1">
              Field of Expertise <span className="fst-italic">(optional)</span>
            </Form.Label>
            {isEditable ? (
              <>
                <Form.Control
                  type="text"
                  value={expertiseValue}
                  onChange={(e) => onExpertiseChange?.(index, e.target.value)}
                  autoComplete="off"
                  name={`candidate-expertise-${index}`}
                  className={expertiseOver ? 'border-danger' : ''}
                />
                {expertiseStatus && (
                  <WordCountIndicator
                    count={expertiseStatus.count}
                    limit={expertiseStatus.limit}
                    over={expertiseStatus.over}
                  />
                )}
              </>
            ) : (
              <div className="ps-2">
                {expertiseValue.trim() || (
                  <span className="text-muted fst-italic">Not specified</span>
                )}
              </div>
            )}
          </Form.Group>
        )}

        {isEditable ? (
          <>
            <Form.Control
              as="textarea"
              rows={20}
              style={{ minHeight: '400px' }}
              value={candidateReport.report}
              onChange={(e) => onChange(index, e.target.value)}
              placeholder=""
              autoComplete="off"
              name={`candidate-report-${index}`}
              className={hasError || fieldStatus.over ? 'border-danger' : ''}
            />
            <WordCountIndicator
              count={fieldStatus.count}
              limit={fieldStatus.limit}
              over={fieldStatus.over}
            />
            {hasError && !fieldStatus.over && (
              <div className="text-danger small mt-1">
                <i className="fas fa-exclamation-circle me-1" />
                Required field
              </div>
            )}
          </>
        ) : (
          <div className="ps-2" style={{ whiteSpace: 'pre-wrap' }}>
            {candidateReport.report?.trim() || (
              <span className="text-muted fst-italic">No report provided</span>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

CandidateReportCard.propTypes = {
  candidateReport: PropTypes.shape({
    candidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    candidateName: PropTypes.string.isRequired,
    candidateRank: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    report: PropTypes.string.isRequired,
    fieldOfExpertise: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  fieldStatus: PropTypes.shape({
    count: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    over: PropTypes.bool.isRequired,
  }).isRequired,
  hasError: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  showExpertise: PropTypes.bool,
  expertiseStatus: PropTypes.shape({
    count: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    over: PropTypes.bool.isRequired,
  }),
  onExpertiseChange: PropTypes.func,
  fieldPrefix: PropTypes.string,
};

export default CandidateReportCard;
